import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';

@Component({
  selector: 'app-invitefirm',
  templateUrl: './invitefirm.component.html',
  styleUrls: ['./invitefirm.component.css']
})
export class InvitefirmComponent extends BaseComponent implements OnInit {

  inviteCompanyFirm: FormGroup;

  constructor(
    private FB: FormBuilder,
    private router: Router
  ) {
    super();
    this._pageTitle = '';
    this.inviteCompanyFirm = FB.group({
      company_name: [''],
      bustat: [''],
      telephone: [''],
      email: ['', [Validators.required]],
      address: [''], 
      url: [''],
      representative: ['']
    })
  }

  ngOnInit(): void {
  }

  sendCompanyInvte() {
    if (this.inviteCompanyFirm.invalid) {
      this._error = "Попълнете задължителните полета"
    }
    this.router.navigate(['invite/sent'])
  }

}
